import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Observable } from 'rxjs';
import { IApiUserAuthenticated } from 'src/app/shared/interfaces/IApiUserAuthenticated';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const user: IApiUserAuthenticated | null = this.authService.getUser;

    if (!user || !user.JwtToken) {
      this.router.navigate(['/login-form']);
      return false;
    }

    const userRole = user.Role;
    const currentPath = route.routeConfig?.path || '';

    // Definir las rutas permitidas para cada rol
    const allowedRoutesForUser = [
      'PedidosMayorista',
      'update-account/:user'
    ];

    const adminOnlyRoutes = [
      'Usuarios',
      'Pedidos',
      'Productos',
      'inicio',
      'ProductosOrden',
      'Envio',
      'Configuracion',
      'pago-mayorista'
    ];

    // Si es Admin, puede acceder a todo
    if (userRole === 'Admin') {
      return true;
    }

    // Si es User, solo puede acceder a las rutas permitidas
    if (userRole === 'User') {
      const isAllowed = allowedRoutesForUser.some(allowedRoute => {
        // Manejar rutas con parámetros como 'update-account/:user'
        if (allowedRoute.includes(':')) {
          const baseRoute = allowedRoute.split('/:')[0];
          return currentPath.includes(baseRoute);
        }
        return currentPath === allowedRoute;
      });

      if (isAllowed) {
        return true;
      } else {
        // Redirigir a la página permitida por defecto para usuarios
        this.router.navigate(['/PedidosMayorista']);
        return false;
      }
    }

    // Si es Repartidor, solo puede acceder a sus rutas
    if (userRole === 'Repartidor') {
      if (currentPath.startsWith('repartidor') || currentPath.includes('update-account')) {
        return true;
      } else {
        this.router.navigate(['/repartidor/mis-envios']);
        return false;
      }
    }

    // Para cualquier otro rol no definido, redirigir al login
    this.router.navigate(['/login-form']);
    return false;
  }
}
